import { render, staticRenderFns } from "./completionSection.vue?vue&type=template&id=56857c1a&scoped=true&"
import script from "./completionSection.vue?vue&type=script&lang=js&"
export * from "./completionSection.vue?vue&type=script&lang=js&"
import style0 from "./completionSection.vue?vue&type=style&index=0&id=56857c1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56857c1a",
  null
  
)

export default component.exports